import { FC } from 'react';

import webView from 'common/webView';
import capDepFundsDepositStep from 'features/Onboarding/images/capDepFundsDepositStep.svg';

import locales from './locales';
import NextStepsCommonLayout from './NextStepsCommonLayout';
import { StepComponentProps } from './types';

const NextStepsFundsDeposit: FC<StepComponentProps> = ({
  email,
  isMandatee,
  onSuccessfulSmsSend,
  onWhatIsNextLinkPress,
}) => (
  <NextStepsCommonLayout
    email={email}
    imageSrc={capDepFundsDepositStep}
    infoSentByMail={locales.fundsDepositSentByMail}
    onSuccessfulSmsSend={onSuccessfulSmsSend}
    onWhatIsNextLinkPress={onWhatIsNextLinkPress}
    stepDescription={locales.fundsDepositDescription}
    stepName={locales.fundsDepositTitle}
    withAppDownloadCard={!isMandatee && !webView.isInWebView}
  />
);

export default NextStepsFundsDeposit;
